/* global femcare */

femcare.product.measurement = {

    init: function () {    
        this.initAccordion();
        this.initToggle();
    },

    initAccordion: function () {
        var $accordion = $('.accordion--measurement');
        if ($accordion.length) {
            femcare.general.accordion.init('.accordion--measurement', 'content');
        }
    },

    initToggle: function () {
        if($('.product-measurement-toggle').length){
            var activeClass = 'product-measurement-toggle__option--active';
            var $options = $('.product-measurement-toggle__option');

            $options.on('click', function (e) {
                
                var $option = $(e.currentTarget);
                var isFirstOption = $option.is(':first-child');
                var isLastOption = !isFirstOption && $option.is(':last-child');
                
                $options.removeClass(activeClass);

                if(isFirstOption){
                    $('.product-measurement__table:last-child').hide();
                    $('.product-measurement__table:first-child').show();
                    $options.filter(':first-child').addClass(activeClass);
                }else if(isLastOption){
                    $('.product-measurement__table:last-child').show();
                    $('.product-measurement__table:first-child').hide();
                    $options.filter(':last-child').addClass(activeClass);
                }
            });
        }
    }
};